import {
  DatePickerComponent,
  TimePickerComponent,
} from "@syncfusion/ej2-react-calendars";
import { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import Successfull from "./Successfull";
import axios from "../../axios";
import ComponentType from "../../Enum/ComponentTypeEnum";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const DraftPublish = ({
  setClick,
  questions,
  assessmentDetails,
  setAssessmentDetails,
  componentType,
  isChecked,
  selectedBox,
}) => {
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [lectureDate, setLectureDate] = useState();

  const [success, setSuccess] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const today = new Date();
  const minDateTime = new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  };
  const [studentList, setStudentList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [lectures, setLectures] = useState();
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [existingAssessment, setExistingAssessment] = useState(null);
  const [pendingCreate, setPendingCreate] = useState(false);

  const [showProcessingDialog, setShowProcessingDialog] = useState(false);
  const isHeavyAssessment = questions.length > 20;
  let schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  let timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  useEffect(() => {
    let students = [];
    let existingStudentsList = [];
    const getStudentList = async () => {
      if (!timeTableSessionId) {
        return;
      }
      try {
        let res = await axios.get(
          `/api/v1/school/student/getList?standardId=${assessmentDetails?.standard_id?.id}&sectionId=${assessmentDetails?.section_id?.id}&timetableSession=${timeTableSessionId}`,
        );

        res &&
          res.data.data.map((student) =>
            students.push({ value: student.id, label: student.name }),
          );

        let existingStudents = null;
        if (componentType == ComponentType.ASSESSMENT) {
          existingStudents = await axios.get(
            `/api/v1/assessment/studentAssessment/getByAssessmentId/${assessmentDetails?.id}?isOnlyList=true`,
          );
        } else if (componentType == ComponentType.HOMEWORK) {
          existingStudents = await axios.get(
            `/api/v1/homework/studentHomework/getByHomeworkId/${assessmentDetails?.id}?isOnlyList=true`,
          );
        }
        existingStudents &&
          existingStudents.data.data.map((student) =>
            existingStudentsList.push({
              value: student.student_id?.id,
              label: student.student_id?.name,
            }),
          );

        setSelectedList(existingStudentsList);

        setStudentList(students);
      } catch (error) {
        console.log(error);
      }
    };

    getStudentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStudentSelection = (selected) => {
    setSelectedList(selected);
  };

  useEffect(() => {
    const getLiveLectureList = async () => {
      if (!academicYearId || !timeTableSessionId) {
        toast.error(
          "These are no allocations set for your login. Please contact school admin for the assistance.",
        );
        return;
      }
      try {
        setLectures([]);
        if (lectureDate !== undefined && assessmentDetails?.deadline) {
          let lectures = await axios.get(
            `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${assessmentDetails?.standard_id?.id}/sectionId/${assessmentDetails?.section_id?.id}/timetableSessionId/${timeTableSessionId}/subjectId/${assessmentDetails?.subject_id?.id}/date/${lectureDate}`,
          );
          lectures && setLectures(lectures?.data?.data[0].lectures);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getLiveLectureList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lectureDate]);

  function convertDateFormat(inputDate) {
    const [day, month, year] = inputDate.split("-");
    const dateObject = new Date(`${year}-${month}-${day}`);
    const convertedYear = dateObject.getFullYear();
    const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, "0");
    const convertedDay = String(dateObject.getDate()).padStart(2, "0");
    const convertedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    return convertedDate;
  }
  const dateHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate() + 1;
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${year}-${month}-${day}`;
    return outputDateString;
  };

  const convertDateFormatLecSess = (date) => {
    const d = new Date(date);

    // Extract date components
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so add 1
    const day = String(d.getDate()).padStart(2, "0");

    // Extract time components
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    const outputDateString = `${hours}:${minutes}`;
    return `${year}-${month}-${day}`;
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const outputDateString = `${hours}:${minutes}`;
    return outputDateString;
  };

  const calculateMinTime = () => {
    if (assessmentDetails?.schedule_date) {
      const startDate = new Date(assessmentDetails.schedule_date);
      if (today.getDate() === startDate.getDate()) {
        startDate.setTime(today.getTime() + 30 * 60000);
      } else {
        startDate.setHours(0, 0, 0, 0);
      }
      return startDate;
    } else {
      // If no date is selected, start from current time + 30 minutes
      const now = new Date();
      now.setMinutes(now.getMinutes() + 30);
      return now;
    }
  };

  const convertUTCToLocalTime = (timeStr) => {
    if (!timeStr) return "";

    const [hours, minutes] = timeStr.split(":").map(Number);

    const date = new Date();
    date.setUTCHours(hours);
    date.setUTCMinutes(minutes);

    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // 👈 AM/PM
    });
  };

  const handleUpdateAssessment = async () => {
    if (isHeavyAssessment) {
      setShowProcessingDialog(true);
    } else {
      setIsInProgress(true);
    }

    // 🔥 ONLY FOR ASSESSMENT (NEW API CHECK)
    // ONLY FOR ASSESSMENT
    if (componentType === ComponentType.ASSESSMENT) {
      try {
        const standardId = assessmentDetails?.standard_id?.id;
        const sectionId = assessmentDetails?.section_id?.id;
        const deadline = assessmentDetails?.schedule_date;
        const scheduleTime = assessmentDetails?.schedule_time;
        const duration = assessmentDetails?.total_duration;

        const checkRes = await axios.get(
          `/api/v1/assessment/checkExisting?standardId=${standardId}&sectionId=${sectionId}&deadline=${deadline}&scheduleTime=${scheduleTime}&duration=${duration}`,
        );

       
        const sameAssessmentId = String(checkRes?.data?.data?.id) === String(assessmentDetails?.id);

        if (checkRes?.data?.status && checkRes?.data?.data && !sameAssessmentId) {
          setExistingAssessment(checkRes.data.data);
          setShowConflictModal(true);
          setIsInProgress(false);
          setShowProcessingDialog(false);
          return;
        }
      } catch (err) {
        console.log("Check existing error:", err);
      }
    }

    // 🔽 OLD CODE (UNCHANGED - SAFE)
    questions = questions.map((val) => {
      if (val.is_question_edited && val.id !== undefined) {
        delete val.id;
      }
      return val;
    });

    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id:
        componentType === ComponentType.ASSESSMENT
          ? null
          : assessmentDetails.type_id,
      assessmentTypeId: assessmentDetails.assessmentTypeId,
      assessmentEventId: assessmentDetails.assessmentEventId,
      ...(componentType === ComponentType.HOMEWORK
        ? {
            academic_session_id: academicSessionId,
            timetable_session_id: timeTableSessionId,
          }
        : {
            academicSessionId: academicSessionId,
            timetableSessionId: timeTableSessionId,
          }),
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      tags: assessmentDetails.tags,
      status: "published",
      total_duration: assessmentDetails.total_duration,
      deadline: assessmentDetails.deadline,
      schedule_date: assessmentDetails.schedule_date,
      schedule_time: assessmentDetails.schedule_time,
      add_to_live_session: assessmentDetails.add_to_live_session,
      isAdaptive:
        selectedBox === "adaptive" ||
        selectedBox?.adaptive ||
        selectedBox?.isAdaptive
          ? true
          : false,
      autoEvalEnabled:
        selectedBox === "auto-evaluate" || selectedBox?.autoEvaluate
          ? true
          : false,
      questions: questions,
    };

    try {
      let res = null;

      if (componentType == ComponentType.ASSESSMENT) {
        res = await axios.put(
          `/api/v1/assessment/update/${assessmentDetails?.id}`,
          newAssessment,
        );
      } else if (componentType == ComponentType.HOMEWORK) {
        res = await axios.put(
          `/api/v1/homework/update/${assessmentDetails?.id}`,
          newAssessment,
        );
      }

      if (res) {
        let students_id = [];
        for (const student of selectedList) {
          students_id.push(student.value);
        }

        let newStudentAssessment = {
          teacher_id: assessmentDetails?.teacher_id,
          student_id: students_id,
          status: "pending",
          deadline: assessmentDetails?.deadline,
        };

        let studentRes = null;

        if (componentType == ComponentType.ASSESSMENT) {
          studentRes = await axios.post(
            `/api/v1/assessment/${res?.data?.data?.id}/studentAssessment/addStudents`,
            newStudentAssessment,
          );
        } else if (componentType == ComponentType.HOMEWORK) {
          studentRes = await axios.post(
            `/api/v1/homework/${res?.data?.data?.id}/studentHomework/addStudents`,
            newStudentAssessment,
          );
        }

        studentRes && setSuccess(!success);
      }
    } catch (error) {
      if (error.message === "No Internet Connection") {
        alert("No Internet Connection");
        return;
      }
      console.log(error);
    } finally {
      setIsInProgress(false);
      setShowProcessingDialog(false);
    }
  };
  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const deadline = assessmentDetails?.schedule_date;
  console.log(deadline);
  if (deadline) {
    var minLiveSessionDate = new Date(deadline);
    minLiveSessionDate.setDate(minLiveSessionDate.getDate() - 6);

    var maxLiveSessionDate = new Date(deadline);
    maxLiveSessionDate.setDate(maxLiveSessionDate.getDate() + 28);
  }
  function convertTimeStringToAMPM(timeString) {
    if (timeString.length !== 4) {
      // Ensure the input string has the correct length
      console.error("Invalid time string format");
      return null;
    }

    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    const formattedTime = `${hours}:${minutes} ${hours < 12 ? "AM" : "PM"}`;
    return formattedTime;
  }
  return (
    <>
      {!success && (
        <div className="publish_transprant_body1">
          {!isInProgress && (
            <div className=" p-4 publish_white_containerPre">
              <>
                <img
                  src="/images/cross-circle3.svg"
                  className="subPrereadClosetBtn"
                  alt=""
                  onClick={(e) => setClick(false)}
                />
                <h5 className="publish_header">Publish</h5>
                <div className=" col-12 publish_field_boxs">
                  {assessmentDetails?.subject_id?.name}
                </div>
                <div className=" col-12 publish_field_boxs">
                  {assessmentDetails?.standard_id?.name}
                </div>
                <div className=" col-12 publish_field_boxs">
                  {assessmentDetails?.section_id?.name}
                </div>
                <div className="my-3">
                  <MultiSelect
                    options={studentList}
                    value={selectedList}
                    onChange={handleStudentSelection}
                    labelledBy="Select"
                    className="custom-multiselect w-100"
                  />
                </div>

                <div className="btn_containers">
                  <div className="toggle_btn">
                    {/* <div className="schedule_btns">
                                            <span>Schedule</span>
                                            <label className="switch">
                                                <Switch
                                                    checked={checked}
                                                    onChange={(event) => {
                                                        setChecked(event.target.checked);
                                                        setChecked1(false);
                                                        setAssessmentDetails({
                                                            ...assessmentDetails,
                                                            schedule_date: null,
                                                            schedule_time: null,
                                                        });
                                                    }}
                                                />
                                            </label>
                                        </div> */}
                    {/* {checked && (
                                            
                                        )} */}
                    {ComponentType.ASSESSMENT === componentType ? (
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "red",
                        }}
                      >
                        Scheduled Date & Time (required)
                      </div>
                    ) : (
                      <div
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "red",
                        }}
                      >
                        Deadline Date (required)
                      </div>
                    )}
                    <>
                      <div className=" schedule_box ">
                        <DatePickerComponent
                          allowEdit={true}
                          showClearButton={false}
                          min={today}
                          isDateDisabled={disablePastDates}
                          id="datepicker"
                          placeholder={
                            ComponentType.ASSESSMENT === componentType
                              ? "Scheduled date"
                              : "Deadline"
                          }
                          value={assessmentDetails?.schedule_date}
                          onChange={(e) => {
                            if (!e.target.value) {
                              setAssessmentDetails({
                                ...assessmentDetails,
                                schedule_date: "",
                              });
                              setChecked1(false);
                            } else {
                              setAssessmentDetails({
                                ...assessmentDetails,
                                schedule_date: convertDateFormatLecSess(
                                  e.target.value,
                                ),
                                deadline: e.target.value,
                              });
                            }
                          }}
                        />
                      </div>
                      {ComponentType.ASSESSMENT === componentType && (
                        <div className="schedule_box  ">
                          <TimePickerComponent
                            min={calculateMinTime()}
                            isDateDisabled={disablePastDates}
                            id="timepicker"
                            placeholder="Scheduled time"
                            onChange={(e) =>
                              setAssessmentDetails({
                                ...assessmentDetails,
                                schedule_time: timeHelper(e.target.value),
                              })
                            }
                          />
                        </div>
                      )}
                    </>
                  </div>
                  <div className="toggle_btn">
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "blue",
                        marginLeft: "6px",
                      }}
                    >
                      Link to Lecture Session (optional)
                    </div>
                    <div className=" schedule_btns p-1 ml-1">
                      {deadline ? (
                        <label className="pt-1 mb-0">
                          <DatePickerComponent
                            id="datepicker"
                            placeholder="Add to Lecture Session"
                            width={230}
                            min={minLiveSessionDate}
                            max={maxLiveSessionDate}
                            allowEdit={false}
                            onChange={(e) => {
                              if (!e.target.value) {
                                setLectureDate(null);
                              } else {
                                setChecked1(true);
                                setLectureDate(formatDate(e.target.value));
                              }
                            }}
                          />
                        </label>
                      ) : (
                        <>
                          <label className="deadlineNotSelect pb-1 pl-1">
                            Add to Lecture Session
                          </label>
                          <img
                            src="/images/calIconDow.png"
                            alt=""
                            className="calDow"
                          />
                        </>
                      )}
                    </div>
                    {checked1 && (
                      <div className="schedule_box border-0 p-0 ml-1">
                        <select
                          className="form-select col-12 py-2 m-0  "
                          id="Schedule_sesion"
                          onChange={(e) =>
                            setAssessmentDetails({
                              ...assessmentDetails,
                              add_to_live_session: {
                                lecture_id: e.target.value,
                                date: convertDateFormat(
                                  e.target.options[
                                    e.target.selectedIndex
                                  ].getAttribute("date"),
                                ),
                              },
                            })
                          }
                        >
                          <option selected>Select Lecture</option>
                          {lectures?.length > 0 &&
                            lectures?.map((lecture, index) => (
                              <option
                                key={index}
                                value={lecture.id}
                                date={lecture.date}
                              >
                                {lecture.name}, {lecture.date},{" "}
                                {convertTimeStringToAMPM(lecture.start_time)}-
                                {convertTimeStringToAMPM(lecture.end_time)}
                              </option>
                            ))}
                        </select>
                      </div>
                    )}
                  </div>
                </div>

                <div className="  publish_btn_box">
                  <button
                    disabled={
                      !assessmentDetails.schedule_date ||
                      !selectedList.length > 0 ||
                      (ComponentType.ASSESSMENT === componentType &&
                        !assessmentDetails.schedule_time)
                    }
                    className="btn publish_btn"
                    onClick={handleUpdateAssessment}
                  >
                    Publish
                  </button>
                </div>
              </>
            </div>
          )}
          {isInProgress && !showProcessingDialog && (
            <div className=" p-4 publish_white_containerPre d-flex justify-content-center align-items-center">
              <img className="" width="150" src="/gif/LoaderDot.gif" alt="" />
            </div>
          )}
        </div>
      )}
      {success && (
        <Successfull setSuccess={setSuccess} componentType={componentType} />
      )}

      {showConflictModal && (
        <Dialog
          open={showConflictModal}
          onClose={() => setShowConflictModal(false)}
          maxWidth="sm"
          fullWidth
        >
          {/* Title */}
          <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WarningAmberIcon color="warning" />
            <Typography variant="h6" fontWeight="bold">
              Conflict Detected
            </Typography>
          </DialogTitle>

          <Divider />

          {/* Content */}
          <DialogContent>
            <Typography variant="body1" sx={{ mb: 2 }}>
              An assessment already exists at this scheduled time.
            </Typography>

            {existingAssessment && (
              <Box
                sx={{
                  background: "#f9fafb",
                  p: 2,
                  borderRadius: 2,
                  border: "1px solid #e5e7eb",
                }}
              >
                <Typography variant="body2">
                  <b>Name:</b> {existingAssessment?.name}
                </Typography>

                <Typography variant="body2">
                  <b>Schedule Time:</b>{" "}
                  {convertUTCToLocalTime(existingAssessment?.schedule_time)}
                </Typography>

                <Typography variant="body2">
                  <b>Duration:</b> {existingAssessment?.total_duration} mins
                </Typography>
              </Box>
            )}

            <Typography variant="body2" sx={{ mt: 2 }}>
              Do you still want to continue?
            </Typography>
          </DialogContent>

          <Divider />

          {/* Actions */}
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => setShowConflictModal(false)}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setShowConflictModal(false);
                setPendingCreate(true);
                handleUpdateAssessment();
              }}
            >
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {showProcessingDialog && (
        <Dialog open={true} maxWidth="xs" fullWidth>
          <DialogContent
            sx={{
              textAlign: "center",
              py: 4,
            }}
          >
            {/* Loader */}
            <Box sx={{ mb: 2 }}>
              <div className="spinner-border text-primary" />
            </Box>

            {/* Title */}
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Saving as Draft...
            </Typography>

            {/* Message */}
            <Typography variant="body2" color="text.secondary">
              Please wait ⏳
              <br />
              This may take a 1-2 minutes due to large number of questions.
            </Typography>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default DraftPublish;
